import React from "react";
import { Link } from "react-router-dom";
import { Arrow } from "./SiteChrome";

export default function ProjectCard({
  project,
  featured = false,
  displayTitle,
}) {
  const title = displayTitle || project.title;

  return (
    <Link
      className={`project-card card-${project.colour}${
        featured ? " is-featured" : ""
      }`}
      to={`/work/${project.slug}`}
      aria-label={`View ${title}`}
    >
      <div className="project-media">
        <img src={project.cover} alt={project.coverAlt} loading="lazy" />
        <span className="project-number">{project.number}</span>
      </div>
      <div className="project-caption">
        <div>
          <span className="project-meta">{project.meta}</span>
          <h3>{title}</h3>
        </div>
        <Arrow />
      </div>
    </Link>
  );
}
